export default {
  common_button_back: 'Tilbage',
  common_button_cancel: 'Annuller',
  common_button_next: 'Næste',
  common_button_no: 'Nej',
  common_button_ok: 'OK',
  common_button_reset: 'Nulstil',
  common_button_skip: 'Spring over',
  common_button_yes: 'Ja',
  common_deactivated_message:
    'Kiosken er blevet aktiveret på en anden iPad og er derfor ikke længere aktiv på denne. Venligst log ind igen, tak.',
  common_deactivated_title: 'Kiosken er deaktiveret på denne iPad',
  common_enterEmail_email: 'Angiv den e-mail, du bruger til dit arbejde',
  common_enterEmail_title: 'Din e-mail',
  common_error_message_cameraNotAllowed:
    'Adgang til kameraet skal være tilladt, for at man kan bruge denne funktionalitet.',
  common_error_message_ForbiddenException: 'Utilstrækkelige rettigheder',
  common_error_message_incorrectEmail: 'Angiv venligst en korrekt email-adresse',
  common_error_message_invalidCredentials: 'Ups! Brugernavn og/eller adgangskode forkert. Prøv venligst igen',
  common_error_message_invalidMobile: 'Venligst angiv et korrekt telefonnummer',
  common_error_message_missingField: 'Obligatorisk felt',
  common_error_message_noInternetConnection: 'Internetforbindelsen er afbrudt. Prøv venligst igen.',
  common_error_message_unauthorizedAccess: 'Uautoriseret adgang',
  common_error_message_webServiceWrongConnection:
    'Der opstod en fejl i forbindelse med dataoverførslen. Prøv venligst igen',
  common_error_title: 'Fejl',
  common_expired_message:
    'Prøveperioden er udlløbet eller det registreret kreditkort er ikke længere valid. Venligst opgrader for at genaktivere din konto. Kontakt sales@proxyclick.com hvis du har spørgsmål. ',
  common_expired_title: 'Konto udløbet',
  common_onboarding_login_button: 'Log ind',
  common_onboarding_message1: 'Proxyclick hjælper dig med at byde din gæster velkommen, præcis som du vil have det.',
  common_onboarding_message2:
    'Brand din tjek ind proces og dine badges, og spørg dine gæster om kun de spørgsmål som passer til dem. ',
  common_onboarding_message3: 'Værten bliver notificeret når gæsten ankommer og kan svare tilbage med det samme.',
  common_onboarding_message4:
    "Beskyt din bygning og sikre compliance gennem nødlister, overvågningslister, NDA's, GDPR regler...",
  common_onboarding_message5: 'Proxyclick gør det hårde arbejde for dig, så du kan møde dine gæster med et smil.',
  common_placeholder_optional: 'Valgfri',
  common_setup_activationCode_activate_button: 'Aktiver',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'f.eks.  YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Ikke valid aktiveringskode',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_title: 'Aktiver kiosk med en unik kode',
  common_setup_device_footer: 'Hvis du vil oprette en ny kiosk, skal du oprette forbindelse til Proxyclick web-appen',
  common_setup_device_locked_content:
    'Denne kiosk er allerede i brug på en anden iPad. Hvis du benytter den på den iPad du har i hænderne nu, deaktiveres kiosken på den anden. Vil du benytte kiosken på denne iPad?',
  common_setup_device_locked_continue_button: 'Opret denne kiosk',
  common_setup_device_locked_title: 'Kiosk allerede i brug',
  common_setup_device_multiTenants: 'Flere virksomheder',
  common_setup_device_title: 'Vælg din kiosk',
  common_setup_loading_footer: 'For at tilpasse din kiosk skal du oprette forbindelse til Proxyclick web-appen',
  common_setup_loading_message: 'Konfigurerer...',
  common_setup_loading_title: 'Din kiosk er ved at blive oprettet...',
  common_setup_location_footer:
    'Hvis du vil oprette et nyt websted, skal du oprette forbindelse til Proxyclick web-appen',
  common_setup_location_kiosk: 'kiosk',
  common_setup_location_kiosks: 'kiosker',
  common_setup_location_title: 'Vælg et websted',
  common_setup_login_activationCode_button: 'Aktiver med unik kode?',
  common_setup_login_email: 'E-mail',
  common_setup_login_forgotPassword_button: 'Har du glemt din adgangskode?',
  common_setup_login_password: 'Adgangskode',
  common_setup_login_title: 'Log ind med din Proxyclick-konto',
  common_setup_ready_header: 'Er du klar til at benytte denne iPad som din {0} kiosk?',
  common_setup_ready_message: 'Det tager kun et øjeblik at konfigurere den, hvorefter din kiosk vil være klar til brug',
  common_setup_ready_setup_button: 'Oprettelse',
  common_setup_ready_title: 'Hej {0}',
  common_signup_company: 'Virksomhed',
  common_signup_email: 'E-mail',
  common_signup_error_name: 'Indtast for- og efternavn',
  common_signup_loading_message1:
    'Du kan tilpasse din kiosk ved oprette forbindelse til Proxyclick web-appen. Vi har netop sendt dig en e-mail med alle oplysningerne om det.',
  common_signup_loading_message2: 'Fra hjemmesiden kan du konfigurere din printer til at udskrive skilte ved check-in.',
  common_signup_loading_message3: 'Du kan også aktivere meddelelser, der skal sendes til værten ved check-in.',
  common_signup_loading_message4: 'Og tilpasse din kiosk med dine egne farver og dit velkomstbillede.',
  common_signup_loading_title: 'Opretter din konto …',
  common_signup_name: 'Navn',
  common_signup_name_placeholder: 'Fornavn Efternavn',
  common_signup_password: 'Adgangskode',
  common_signup_title: 'Velkommen til Proxyclick',
  common_signup_tryFree_button: 'Send',
  common_timeout_content: 'Tryk for at afbryde',
  common_timeout_title: 'Vender tilbage til startskærmen',
  common_tooltip_disable_button: 'Deaktiver alle tips',
  common_tooltip_gotIt_button: 'Forstået',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} er blevet informeret om, at du har leveret en pakke',
  dm_delivery_confirmation_title: 'Tak!',
  dm_delivery_confirmation_unknownRecipient:
    'Notifikation er afsendt for at fortælle {{Company_Name}} at en pakke er blevet leveret til dem',
  dm_delivery_recipient_name: 'Hvem er pakken til?',
  dm_delivery_recipient_unknown_button: 'Jeg ved det ikke',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_confirmation_header_withoutPrint: 'Du er blevet registreret!',
  vm_checkin_confirmation_header_withPrint: 'Dit skilt udskrives',
  vm_checkin_confirmation_message: 'Sid venligst ned, {{Host_FirstName}} vil være her om et øjeblik',
  vm_checkin_confirmation_takeBackID: 'Glem ikke dit ID',
  vm_checkin_confirmation_title: 'Tak!',
  vm_checkin_details_companyName: 'Virksomhed',
  vm_checkin_details_email: 'E-mail',
  vm_checkin_details_firstname: 'Fornavn',
  vm_checkin_details_lastname: 'Efternavn',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_error_message_unableToCheckIn:
    'Der opstod en fejl i forbindelse med dit check-in, du bedes kontakte receptionen',
  vm_checkin_flow_company: 'Virksomhed',
  vm_checkin_flow_duration: 'Varighed af besøg',
  vm_checkin_flow_email: 'E-mail',
  vm_checkin_flow_error_message_imageNotAvailable:
    'Ups, billedet er for øjeblikket ikke tilgængeligt (problem med internetforbindelsen)',
  vm_checkin_flow_licensePlate: 'Nummerplade',
  vm_checkin_flow_mobile: 'Venligst angiv dit mobil nummer',
  vm_checkin_flow_mobile_info: 'Dette vil blive brugt i tilfælde af en nødsituation, mens du befinder dig i bygningen',
  vm_checkin_flow_tooltip_content:
    'Stil dine besøgende spørgsmål, som kan hjælpe dig til at forbedre deres oplevelse eller gøre check-in-processen mere sikker. Du kan justere de spørgsmål der stilles alt afhængig af de besøgendes svar. De spørgsmål der vises er blot demonstrationsprøver.',
  vm_checkin_flow_tooltip_title: 'Intelligente spørgsmål',
  vm_checkin_host_enterFullName: 'Angiv venligst din værts fulde navn',
  vm_checkin_host_name: 'Hvem skal du besøge?',
  vm_checkin_host_notListed_block:
    'Spørg venligst receptionisten, hvis du ikke kender din vært, eller ikke kan finde ham/hende på listen',
  vm_checkin_host_notListed_continue: 'Er ikke på listen',
  vm_checkin_host_tooltip_content:
    'Skriv dit navn her, så sender vi dig den e-mail-meddelelse, som dine medarbejdere får, når deres besøgende ankommer.',
  vm_checkin_host_tooltip_title: 'Meddelelse om besøgendes ankomst',
  vm_checkin_host_unknown_button: 'Jeg ved det ikke',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_header: 'Scan venligst dit ID',
  vm_checkin_idScan_aila_learnMore: 'Læs mere',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_back_picture_header_aila: 'Placer dit ID i holderen, så bagsiden vender mod kameraet.',
  vm_checkin_idScan_back_picture_header_noAila: 'Placer dit ID, så bagsiden vender mod kameraet.',
  vm_checkin_idScan_back_picture_take_button: 'Scan bagside',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_idScan_cancel_title: 'Advarsel',
  vm_checkin_idScan_disclaimer_start_button: 'Lad os komme igang',
  vm_checkin_idScan_disclaimer_text:
    'Som en del af vores sikkerhedspolitik er vi nødt til at bekræfte din identitet ved hjælp af din ID.\n\nVi værdsætter dit privatliv, så vi lagrer ikke billedet af dit ID. Receptionisterne kan hjælpe, hvis du har spørgsmål.',
  vm_checkin_idScan_editName_title: 'Udfyld venligst dit for- og efternavn',
  vm_checkin_idScan_front_picture_header_aila: 'Placer dit ID i holderen, så forsiden vender mod kameraet.',
  vm_checkin_idScan_front_picture_header_noAila: 'Placer dit ID, så forsiden vender mod kameraet.',
  vm_checkin_idScan_front_picture_take_button: 'Scan forside',
  vm_checkin_idScan_match_check: 'Sammenligner de to billeder',
  vm_checkin_idScan_match_confirm_button: 'Bekræft',
  vm_checkin_idScan_match_error_default_header: 'Undskyld, noget gik galt.',
  vm_checkin_idScan_match_error_default_message: 'Spørg en receptionist om hjælp eller prøv igen.',
  vm_checkin_idScan_match_error_idExpired_header: 'Beklager, dit ID ser ud til at være udløbet.',
  vm_checkin_idScan_match_error_idExpired_message: 'Spørg en receptionist om hjælp eller prøv igen.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Vi kunne desværre ikke identificere et ansigt på dit ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Spørg en receptionist om hjælp eller prøv igen.',
  vm_checkin_idScan_match_error_pictureNoFace_header:
    'Vi kunne desværre ikke identificere et ansigt på det billede, du tog.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Spørg en receptionist om hjælp eller prøv igen.',
  vm_checkin_idScan_region_0: ' USA',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'Sydamerika',
  vm_checkin_idScan_region_3: ' Europa',
  vm_checkin_idScan_region_4: ' Australien',
  vm_checkin_idScan_region_5: ' Asien',
  vm_checkin_idScan_region_6: 'Generelle Dokumenter',
  vm_checkin_idScan_region_7: ' Afrika',
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_instructions_agreeTerms_button: 'Enig',
  vm_checkin_instructions_clearSignature_button: 'Ryd',
  vm_checkin_instructions_sendCopy_button: 'Send mig en kopi via e-mail',
  vm_checkin_instructions_sendCopyTo_button: 'Der sendes en kopi til {0} (Rediger)',
  vm_checkin_instructions_sign: 'Underskriv her med din finger',
  vm_checkin_instructions_tooltip_content:
    'Få dine gæster til at acceptere dine regler for besøgende med et enkelt tryk eller en underskrift. Du kan tilpasse dine vilkår afhængigt af hvilken type af besøgende det er, der checker ind. Tilpas denne funktion og mange andre i Proxyclick-kontrolpanelet.',
  vm_checkin_instructions_tooltip_title: 'Underskrevet og godkendt',
  vm_checkin_method_name: 'Hej, hvad er dit navn?',
  vm_checkin_method_name_enterFullName: 'Indtast dit fulde navn',
  vm_checkin_method_name_invitationQuestion: 'Did you receive an invitation with a QR-code?',
  vm_checkin_method_name_notRegistered_block: 'Ikke på listen? Forhør dig venligst hos receptionen',
  vm_checkin_method_name_notRegistered_continue: 'Ikke på listen?',
  vm_checkin_method_tooltip_content:
    'Check ind som "Justin Diaz", for at se hvordan tilbagevendende eller forud registrerede besøgende genkendes.\n\nEller skriv et tilfældigt navn, for at se hvordan uventede besøgende modtages.',
  vm_checkin_method_tooltip_title: 'Genkendelse af besøgende',
  vm_checkin_picture_auto_countDown: 'Tag billede om',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_pictureTaken: 'Billede taget',
  vm_checkin_picture_auto_stayStill: 'Stå stille',
  vm_checkin_picture_take_button: 'Tag et billede',
  vm_checkin_picture_title: 'Lad os tage dit billede!',
  vm_checkin_picture_tooltip_content:
    'Du kan skræddersy kiosken efter dine behov og nemt tilføje eller fjerne funktioner, som for eksempel tager billeder af de besøgende eller udskriver skilte.',
  vm_checkin_picture_tooltip_title: 'Valgfri funktioner',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_checkin_returning_email: 'Hej, hvad er din e-mailadresse?',
  vm_checkin_returning_email_notRegistered: 'Ikke fundet? Kontakt venligst receptionen',
  vm_checkin_saveInfo_email: 'Gem mine informationer, så tjek ind går hurtigere næste gang.',
  vm_checkin_saveInfo_email_placeholder: 'Angiv din e-mailadresse',
  vm_checkin_saveInfo_title: 'Angiv din e-mailadresse',
  vm_checkin_summary_agreementAlreadySigned: 'Dokument allerede underskrevet',
  vm_checkin_summary_checkin_button: 'Check ind',
  vm_checkin_summary_countDown: 'Dit check-in gennemføres om',
  vm_checkin_summary_editDetails_button: 'Rediger detaljer',
  vm_checkin_summary_groupStats: '{0} ud af {1} deltagere er allerede ankommet',
  vm_checkin_summary_meetingTime: 'Møde hos {0}',
  vm_checkin_summary_reviewDetails_button: 'Gennemse oplysningerne om mit besøg',
  vm_checkin_summary_sendPass_button: 'Send mig en billet til fremtidige besøg via min smartphone',
  vm_checkin_summary_sendPassTo_button: 'En permanent billet vil blive sendt til {0} (Rediger)',
  vm_checkin_summary_takeNewPicture_button: 'Tag nyt billede',
  vm_checkin_summary_title: 'Dit besøg hos {{Company_Name}}',
  vm_checkin_summary_visiting: 'Besøg hos {0}',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_welcome_firstTime: 'Velkommen {{Visitor_FirstName}}!',
  vm_checkin_welcome_lastVisit_date: 'De seneste besøg var ',
  vm_checkin_welcome_lastVisit_today: 'Dit sidste besøg var tidligere i dag',
  vm_checkin_welcome_lastVisit_yesterday: 'Dit sidste besøg var i går',
  vm_checkin_welcome_returning: 'Velkommen tilbage {{Visitor_FirstName}}!',
  vm_checkout_confirmation_header: 'Farvel {{Visitor_FirstName}}!',
  vm_checkout_confirmation_message: 'Du er blevet checket ud. Vi håber du har nydt dit besøg.',
  vm_checkout_confirmation_title: 'Tak for dit besøg!',
  vm_checkout_method_name: 'Indtast dit navn for at tjekke ud',
  vm_checkout_method_name_notFound: 'Ikke fundet',
  vm_checkout_method_title: 'Lad os checke ud',
  vm_identification_id_button: 'Skan dit ID',
  vm_identification_qrCode_button: 'Skan din invitation/billet',
  vm_infopack_confirmation: 'Tak!\nVi har sendt oplysningerne til {0}.',
  vm_infopack_email: 'Indtast venligst din e-mail, så vi kan sende dig oplysninger om Proxyclick',
  vm_infopack_likeCheckIn: 'Kunne du lide denne tjek ind? Klik her for flere informationer',
  vm_infopack_likeProcess: 'Kunne du lide denne proces? Klik her for flere informationer',
  vm_infopack_send_button: 'Send oplysninger til mig',
  vm_multiTenant_title: 'Velkommen, hvilken virksomhed besøger du?',
  vm_product_footer_learnMore: 'Læs mere',
  vm_product_footer_noPartner: 'Du bruger Proxyclick Velkommen',
  vm_product_footer_partner: 'Proxyclick, i samarbejde med {0}',
  vm_qrCode_help: 'Hold din kode 10-15 cm fra kameraet',
  vm_qrCode_not_recognized: 'Koden blev ikke genkendt',
  vm_qrCode_title: 'Skan dit skilt eller din kode',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>VEJLEDNING TIL BESØGENDE OG AFTALE OM FORTROLIGHED</h1><p>Velkommen! Vi er glade for at modtage dig her på vores faciliteter som gæst hos {{Company_Name}}.</p> <h2>Vejledning vedrørende sundhed og sikkerhed</h2> <p>Vi ønsker at varetage din personlige sikkerhed under hele dit besøg. Vi anmoder derfor om at du overholder følgende:</p> <ul><li><b>Adgang til lokaler</b> er kun tilladt, under ledsagelse af en medarbejder fra {{Company_Name}} </li> <li>Den besøgendes <b>skilt</b> skal hele tiden bæres, og skal afleveres til receptionen, når besøget er slut</li> <li>I tilfælde af en <b>nødsituation</b> skal alle besøgende forlade stedet øjeblikkeligt via den nærmeste sikre udgang og begive sig til det udpegede samlingssted</li> <li>Besøgende <b>må ikke tage billeder</b> (foto eller video) af noget som helst i lokalerne eller på området omkring faciliteterne</li> <li><b>Rygning er strengt forbudt</b> inde i bygningen</li></ul><h2>Aftale om hemmeligholdelse</h2><p>Under dit besøg på {{Company_Name}}\'s faciliteter, vil du muligvis erfare og/eller modtage proprietære eller fortrolige oplysninger (herunder, uden begrænsninger, oplysninger vedrørende teknologi, processer, udstyr, tegninger og specifikationer) der ikke generelt er offentligt kendt (herefter samlet betegnet &#34; Fortrolige oplysninger &#34;).</p> <p>I betragtning af din tilladelse til at besøge {{Company_Name}}\'s faciliteter og den gæstfrihed du er blevet vist under dit besøg, indvilliger du i, at du ikke vil hverken;</p> <p>(a) Afsløre eller på anden måde videregive fortrolige oplysninger, som du modtager i forbindelse med dette og eventuelle senere besøg; eller</p> <p>(b) Bruge eller hjælpe andre med på nogen måde at bruge eller videreudvikle nogen som helst fortrolige oplysninger.</p> <p>(c) Bruge kameraer eller video-teknologi til at videregive fortrolige oplysninger.</p> <p>Ved at indskrive dig på faciliteterne, udtrykker du at du anerkender og forstår oplysningerne i Vejledning vedrørende sundhed og sikkerhed samt Aftale om hemmeligholdelse.</p>',
  vm_signup_defaultInstruction_name: 'Vejledning som skal underskrives af alle besøgende',
  vm_signup_defaultInstruction_title: 'Læs venligst, og underskriv forneden',
  vm_vaccine_certification_accessDenied_button: 'Okay',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_welcome_changeLanguage_button: 'Change Language',
  vm_welcome_checkin_button: 'Check ind',
  vm_welcome_checkout_button: 'Check ud',
  vm_welcome_delivery_button: 'Levering',
  vm_welcome_hello_line1: 'Hej,',
  vm_welcome_hello_line2: 'til {{Company_Name}}',
  vm_welcome_qrCode_checkedIn: 'Velkommen {0}, husk at checke ud, når du rejser',
  vm_welcome_qrCode_checkedOut: 'Vi ses snart {0}!',
  vm_welcome_qrCode_notRecognized: 'Kode ikke genkendt. Forsøg igen om 3 sek...',
  vm_welcome_qrCode_scan: 'Scan QR-koden modtaget i invitationen for check-in eller check-out',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_returning_button: 'Jeg har været her før',
  vm_welcome_title: 'Velkommen til {{Company_Name}}',
  vm_welcome_tooltip_content:
    'For at tilpasse din kiosk, skal du logge på Proxyclick web-appen. Vi har netop sendt dig en e-mail med instruktioner. I web-appen kan du uploade dit logo, et baggrundsbillede og vælge en farve, så din kiosk afspejler din virksomheds identitet.',
  vm_welcome_tooltip_title: 'Giv den dit eget særpræg',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scan this QR code with Proovr (employees) or your phone (visitors) to check in',
  vm_welcome_touchless_unexpected_qrCode_show: 'Scan this QR code with your phone to check in as a visitor',
  common_or: 'eller',
};
